:host {
  display: grid;
  place-items: center;
  padding: 1rem;
}

@media (min-width: 1024px) {
  :host {
    padding: 2rem;
  }
}

@media (min-width: 1350px) {
  :host {
    padding: 3rem;
  }
}

::slotted(*) {
  width: 100%;
}

::slotted(:first-child) {
  margin-top: auto;
  margin-bottom: 0;
  font-size: 30px;
  line-height: 1.2;
  font-family: var(--cwc-font-sans-serif-semibold, 'Eina01-SemiBold');
  font-weight: 400;
}

::slotted(:not(:first-child)) {
  margin-top: 24px;
  margin-bottom: auto;
  font-size: 24px;
  line-height: 1.25;
  font-family: var(--cwc-font-sans-serif-light, 'Eina01-Light');
  font-weight: 400;
}

::slotted(.card-link) {
  color: var(--cwc-color-white, #fff) !important;
}

::slotted(.card-link:hover) {
  color: var(--cwc-color-white, #fff) !important;
  text-decoration: underline;
}
